import * as React from "react";

const SvgIcnBulbBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M12 4c.839 0 1.623.148 2.354.445a6.11 6.11 0 011.904 1.203 5.62 5.62 0 011.275 1.782c.311.682.467 1.409.467 2.18 0 1.093-.227 1.926-.68 2.5a9.269 9.269 0 01-1.41 1.453c-.363.291-.652.544-.868.757a1.05 1.05 0 00-.322.774v.844c0 .01-.003.02-.009.03a.065.065 0 00-.008.032h.017v1.453c0 .76-.25 1.375-.748 1.844-.499.469-1.15.703-1.955.703-.827 0-1.49-.234-1.989-.703-.498-.469-.748-1.083-.748-1.844V16h.017c0-.01-.002-.02-.008-.031a.065.065 0 01-.009-.031v-.844c0-.198-.096-.388-.288-.57a14.88 14.88 0 00-.765-.665c-.488-.406-.98-.924-1.48-1.554C6.25 11.675 6 10.776 6 9.609c0-.77.156-1.497.467-2.18a5.62 5.62 0 011.275-1.78 6.11 6.11 0 011.904-1.204A6.195 6.195 0 0112 4zm-.017 15c.521 0 .926-.135 1.215-.406.29-.271.434-.651.434-1.14v-.688a5.093 5.093 0 01-.697.164A5.55 5.55 0 0112 17a6.19 6.19 0 01-.943-.063 4.52 4.52 0 01-.689-.156v.672c0 .48.142.857.425 1.133.283.276.68.414 1.19.414z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnBulbBold;
